//
import Service from '@/services/api/service'
import AccountTypeModel from '@/models/Accounting/AccAccountType'

//
import filters from './filters'
import headers from './headers'

//
export default class extends Service {

    //
    static filters  = filters
    static headers  = headers
    static includes = [
        '',
    ]
    
    //
    static model = AccountTypeModel
}
